import Vue from 'vue'
import { contrato as routing } from '../util/routes'

export default {
  state: {
    industriaDoCliente: {},
    industriasDoCliente: []
  },
  mutations: {
    setIndustriaDoCliente: (state, payload) => {
      state.industriaDoCliente = payload
    },
    setIndustriasDoCliente: (state, payload) => {
      state.industriasDoCliente = payload
    }
  },
  actions: {
    async getContratos ({ commit }) {
      commit('setIndustriasDoCliente', [])
      const { data } = await Vue.axios.get(`${routing}`)
      commit('setIndustriasDoCliente', data)
    },
    async getIndustriaDoCliente ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setIndustriaDoCliente', data)
    },
    async postSaveIndustriaDoCliente ({ state }, { clienteId }) {
      const { industriaDoCliente } = state
      if (industriaDoCliente.id) {
        const user = await Vue.axios.put(
          `${routing}/${industriaDoCliente.id}`,
          industriaDoCliente
        )
        return user
      }
      industriaDoCliente.cliente_id = clienteId
      return Vue.axios.post(`${routing}`, industriaDoCliente)
    },
    async deleteIndustriaDoCliente ({ state }) {
      const { industriaDoCliente } = state
      return Vue.axios.delete(`${routing}/${industriaDoCliente.id}`)
    }
  },
  getters: {
    industriaDoCliente: ({ industriaDoCliente }) => industriaDoCliente,
    industriasDoCliente: ({ industriasDoCliente }) => industriasDoCliente
  }
}
